import Model from './Model'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import advancedFormat from 'dayjs/plugin/advancedFormat'

dayjs.extend(utc)
dayjs.extend(advancedFormat)

export default class GroupSession extends Model {
  resource() {
    return 'sessions'
  }

  get scheduleDate() {
    return dayjs.utc(this.session_datetime).format('hh:mm A ddd Do MMMM')
  }
}
